import { Resources } from "@app/resources";
import { referenceRoute } from "@common/references/reference-routing.data";
import { UsersService } from '@modules/settings/users/users.service';
import { PropertiesService } from '@modules/settings/properties/properties.service';
import { TariffsService } from '@modules/settings/tariffs/tariffs.service';
import { MetersService } from '@modules/settings/meters/meters.service';
import { TaxesService } from '@modules/settings/taxes/taxes.service';
import { MeterTypeService } from '@modules/settings/meter-type/meter-type.service';
import { UnitTypesService } from '@modules/settings/unit-types/unit-types.service';
import companyDetailsRouting from '@modules/settings/companies/company-details/company-details.routing';

export default {
  path: Resources.Settings,
  children: [
    {
      path: Resources.SettingsAddresses,
      loadComponent: () => import('./addresses/addresses.component').then(c => c.AddressesComponent),
    },
    {
      path: Resources.SettingsCompanies,
      loadComponent: () => import('./companies/companies.component').then(c => c.CompaniesComponent),
    },
    companyDetailsRouting,
    referenceRoute(Resources.SettingsUsers, UsersService),
    referenceRoute(Resources.SettingsTariffs, TariffsService),
    referenceRoute(Resources.SettingsMeters, MetersService),
    // referenceRoute(Resources.SettingsUtilityRates, UtilityRatesService),
    // referenceRoute(Resources.SettingsUtilityTypes, UtilityProviderTypesService),
    // referenceRoute(Resources.SettingsUtilityProviders, UtilityProvidersService),
    referenceRoute(Resources.SettingsTaxes, TaxesService),
    referenceRoute(Resources.SettingsMeterType, MeterTypeService),
    referenceRoute(Resources.SettingsUnitTypes, UnitTypesService),
    {
      path: Resources.SettingsProperties,
      loadComponent: () => import('@modules/settings/properties/properties.component').then(c => c.PropertiesComponent),
    },
    {
      path: Resources.SettingsNotifications,
      loadComponent: () => import('@modules/settings/notifications/notifications.component').then(c => c.NotificationsComponent),
    },
    {
      path: Resources.SettingsActivityLogs,
      loadComponent: () => import('@modules/settings/activity-logs/activity-logs.component').then(c => c.ActivityLogsComponent),
    },
    {
      path: Resources.SettingsApartments,
      loadComponent: () => import('@modules/settings/apartments/apartments.component').then(c => c.ApartmentsComponent),
    },
    referenceRoute(Resources.Properties, PropertiesService),
    {
      path: Resources.SettingsPropertyConfigurations,
      loadComponent: () => import('@modules/settings/properties/property-configurations/property-configurations.component').then(c => c.PropertyConfigurationsComponent),
    },
    {
      path: Resources.SettingsRoles,
      loadComponent: () => import('@modules/settings/roles/roles.component').then(c => c.RolesComponent),
    },
    {
      path: Resources.SettingsSettings,
      loadComponent: () => import('@modules/settings/settings/settings.component').then(c => c.SettingsComponent),
    },
    {
      path: Resources.SettingsTranslations,
      loadComponent: () => import('@modules/settings/translations/translations.component').then(c => c.TranslationsComponent),
    },
  ]
}
